import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import isEqual from 'lodash.isequal';

// Global Types
import { AppState } from 'services/types';

// Global Actions
import {
    requestLoadFertilizerEvents,
    cancelLoadFertilizerEvents
} from 'services/fertilizerEvents/actions';

import { selectLoadFertilizerEventsParams } from 'services/fertilizerEvents/params';

interface ConnectedProps {
    params?: Record<string, any>;
}

interface DispatchProps {
    requestLoadFertilizerEvents: typeof requestLoadFertilizerEvents;
    cancelLoadFertilizerEvents: typeof cancelLoadFertilizerEvents;
}

type Props = ConnectedProps & DispatchProps;

export class FertilizerEventsRequestComponent extends React.PureComponent<Props> {
    componentDidMount(): void {
        const { props } = this;
        props.requestLoadFertilizerEvents();
    }

    componentDidUpdate(prevProps: Props): void {
        const { props } = this;
        if (!isEqual(prevProps.params, props.params)) {
            props.requestLoadFertilizerEvents();
        }
    }

    componentWillUnmount(): void {
        const { props } = this;
        props.cancelLoadFertilizerEvents();
    }

    render(): null {
        return null;
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    params: selectLoadFertilizerEventsParams
});

export default connect(mapStateToProps, {
    requestLoadFertilizerEvents,
    cancelLoadFertilizerEvents
})(FertilizerEventsRequestComponent);
